/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';

import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import MiniImageSlide from 'components/MiniImageSlide';
import { withStyles } from '@material-ui/styles';

const ViewGallery = ({ classes, urls }) => {
  const [showGallery, setShowGallery] = useState(false);
  const [fullImage, setFullImage] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    document.body.style.overflow = showGallery ? 'hidden' : 'auto';
  }, [showGallery]);

  const handleClick = e => {
    const elWidth = e.currentTarget.offsetWidth;
    const center = elWidth / 2;

    if (center < e.pageX) {
      setPhotoIndex(photoIndex + 1 > urls.length - 1 ? 0 : photoIndex + 1);
    } else {
      setPhotoIndex(photoIndex - 1 < 0 ? urls.length - 1 : photoIndex - 1);
    }
  };

  return (
    <>
      <div
        className={classes.modal}
        style={{
          display: showGallery ? 'block' : 'none',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '40px',
            padding: '0 24px',
          }}
        >
          <ArrowBackIos
            onClick={() => {
              if (fullImage) {
                setFullImage(false);
              } else {
                setShowGallery(false);
              }
            }}
          />
          {fullImage && (
            <Typography>
              {photoIndex + 1}/{urls.length}
            </Typography>
          )}
        </div>

        <div style={{ marginTop: '26px' }}>
          {fullImage && (
            <Box onClick={handleClick} textAlign="center" className={classes.containerFullImage}>
              <img
                src={urls[photoIndex]}
                alt={photoIndex + 1}
                style={{ maxWidth: '100%', maxHeight: 'calc(100vh - 95px)' }}
              />
            </Box>
          )}

          {!fullImage && (
            <div className={classes.grid}>
              {urls.map((item, index) => (
                <Box
                  key={item}
                  style={{
                    backgroundImage: `url('${item}')`,
                  }}
                  onClick={() => {
                    setPhotoIndex(index);
                    setFullImage(true);
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <Box mb={2}>
        <MiniImageSlide list={urls} onClick={() => setShowGallery(true)} height="360px" />
      </Box>
    </>
  );
};
ViewGallery.propTypes = {
  classes: PropTypes.object.isRequired,
  urls: PropTypes.array.isRequired,
};

const styles = theme => ({
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 4000,
    backgroundColor: '#ffffff',
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  containerFullImage: {
    position: 'absolute',
    height: 'calc(100vh - 95px)',
    width: '100%',
  },

  grid: {
    maxWidth: '1028px',
    margin: 'auto',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.only('sm')]: {
      gridTemplateColumns: '1fr 1fr 1fr',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
    },
    gridGap: '10px',
    '& div': {
      minHeight: '181px',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    '& div:nth-child(1)': {
      gridColumn: 'span 2',
      height: '100%',
      minHeight: '360px',
      [theme.breakpoints.only('sm')]: {
        gridColumn: 'span 3',
      },
      [theme.breakpoints.up('md')]: {
        gridColumn: 'span 4',
      },
    },
  },
});
export default withStyles(styles)(ViewGallery);
